
























































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import {
  getJobStats,
  getJobs,
  updateJob,
} from '@/api';
import useAuth from '@/use/useAuth';
import dashboardOption from '@/table/PurchaseOrder/dashboard';
import saleJobTableOption from '@/table/Job/sale-department';
import useSubJob from '@/use/useSubJob';

import CommonCheckBoxRenderer from '@/components/CommonCheckBoxRenderer.vue';
import CommonModalWithJobExporter from '@/components/Dashboard/CommonModalWithJobExporter.vue';

const SaleDashboard = defineComponent({
  components: {
    CommonCheckBoxRenderer,
    CommonModalWithJobExporter,
  },
  setup(props, { root }) {
    const { router, route } = useRouter();
    const { list: processStatusList } = useSubJob();
    const { hasPermission: checkPermissionHandler } = useAuth();
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const clickRowHandler = (row: any) => router.push({ name: 'JobDetail', params: { id: row.item.id } });
    const refetchQuery = ref(false);
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();

    const filter: { searchString?: string; target_date?: string, filterOverdue?: boolean | null, filterType?: string, filterCreatedAt?: string, searchCustomer?: string; } = reactive({
      target_date: '',
      searchString: '',
      searchCustomer: '',
      filterOverdue: null,
      filterType: '',
      filterCreatedAt: '',
    });
    const projectStats = reactive({
      TOTAL: 1,
      WITHDRAW: 1,
      OVERDUE: 1,
    });
    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    const stats = reactive({
      total: 0,
      withdrawing: 0,
      overDue: 0,
      inProgressBomItem: 0,
      qcBomItem: 0,
    });

    function filterOverdueHandler($event: boolean) {
      if (!filter.filterOverdue) {
        filter.filterOverdue = true;
        router.push({ name: route.value.name, query: { overdue: 'true' } });
        refetchQueryHandler();
      }
    }

    onMounted(async () => {
      const resultStats = await getJobStats();
      stats.total = resultStats.total;
      stats.withdrawing = resultStats.withdrawing;
      stats.overDue = resultStats.overdue;
      stats.inProgressBomItem = resultStats.inProgressBomItem;
      stats.qcBomItem = resultStats.qcBomItem;
    });

    async function updateSingleJobStatus(id: number, payload: { status?: string }) {
      await updateJob(id, payload);
      refetchQuery.value = true;
    }

    return {
      toCurrencyWithoutSign,
      processStatusList,
      filterOverdueHandler,
      toDate,
      hasPermission,
      stats,
      projectStats,

      updateSingleJobStatus,

      getJobs,
      filter,
      clickRowHandler,
      saleJobTableOption,
      refetchQuery,
      refetchQueryHandler,
    };
  },
});

export default SaleDashboard;
